import Axios from 'axios';
import store from '@/store';

const axios = Axios.create({
    baseURL: (process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : '') + process.env.VUE_APP_API,
    withCredentials: true,
    headers: {
        'X-Frame-Options': 'SAMEORIGIN',
        'Content-Security-Policy': `script-src "self" ${window.location.origin}`,
        'Permissions-Policy': `geolocation=(self ${window.location.origin})`
    }
});

axios.interceptors.response.use((response)=>{
            return Promise.resolve(response)
        }, (e) => {
            if (e.response && e.response.status == 401 && store.getters.authorized == 'authorized' && !/user\/info\/$/.test(e.request.responseURL)){
                if (store.getters.loader.show) {
                    store.dispatch('setLoader');
                }
                store.commit('setSession');
            }
            else if(e.response && e.response.status == 423){
                if(e.response.data.errorMessage == 'Role block '){
                    store.commit('setAccessRole');
                }
                else if (route.name !== 'Login'){
                    store.commit('setAccessUser');
                }
            }
            return Promise.reject(e);
        });

export { axios };
